import React from 'react';
import {
  HeaderBar,
  LogoImageSlot,
  HeaderSection,
  WelcomeWrapper,
  WelcomeText,
  GuestName,
} from './styles';
import WeatherWidget from '../WeatherWidget';
import { useHeaderData } from '../../../common/useHeaderData';
import { translate as t } from 'utils/i18n';
import RoomInfoBadge from '../RoomInfoBadge';
import CachedImg from 'components/common/CachedImg/CachedImg';

export default function HeaderBarComponent() {
  const { dateTime, weatherData, customerData, roomData, organizationLogoUrl } = useHeaderData();

  return (
    <HeaderBar>
      <HeaderSection>
        {organizationLogoUrl ? (
          <LogoImageSlot>
            <CachedImg src={organizationLogoUrl} alt="" />
          </LogoImageSlot>
        ) : (
          ''
        )}
        {customerData?.guest_name && (
          <WelcomeWrapper>
            <WelcomeText>{t('WelcomeNote.welcome') || 'Welcome'}</WelcomeText>
            <GuestName>{customerData?.guest_name ?? ''}</GuestName>
          </WelcomeWrapper>
        )}
      </HeaderSection>

      <HeaderSection>
        {roomData?.room_no && (
          <RoomInfoBadge
            roomNumber={roomData?.room_no}
            roomType={roomData?.building}
            floor={roomData?.floor}
          />
        )}
        <WeatherWidget weather={weatherData} time={dateTime.time} />
      </HeaderSection>
    </HeaderBar>
  );
}
